import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Log } from '@capital-access/common/logging';
import { ReportingTemplateRequest, ReportTemplate, ReportTemplateFormType } from '@capital-access/reporting/common';
import { MAX_TEMPLATE_DESCRIPTION_LENGTH_LIMIT, MAX_TEMPLATE_NAME_LENGTH_LIMIT } from '../constants';
import { ReportTemplateFormOptions } from '../models/reporting-template-form.model';
import { invalidSymbolsValidator, UniqueTemplateNameValidator } from './template-validators';
export const getForm = (
  type: ReportTemplateFormType,
  values: Partial<ReportingTemplateRequest> = {} as ReportingTemplateRequest,
  options: ReportTemplateFormOptions
): FormGroup => {
  const templateForm = new FormGroup({
    templateName: new FormControl(
      '',
      [Validators.required, Validators.maxLength(MAX_TEMPLATE_NAME_LENGTH_LIMIT), invalidSymbolsValidator()],
      UniqueTemplateNameValidator.createValidator(options.templateLibraryRepository, options.changeDetector)
    ),
    description: new FormControl('', [Validators.maxLength(MAX_TEMPLATE_DESCRIPTION_LENGTH_LIMIT)]),
    pageSize: new FormControl('us-letter', [Validators.required])
  });
  if (
    type === ReportTemplateFormType.edit ||
    type === ReportTemplateFormType.duplicate ||
    type === ReportTemplateFormType.duplicateWithoutContinue
  ) {
    templateForm.patchValue(values);
  }
  return templateForm;
};
export const createFormValueFromTemplate = (
  selectedTemplate: ReportTemplate | null,
  actionType: ReportTemplateFormType,
  templatesList: ReportTemplate[],
  createReportSectionSettings: string | null
): ReportingTemplateRequest => {
  let data!: ReportingTemplateRequest;
  const parsedObject = JSON.parse(createReportSectionSettings ?? '{}'); // Use '{}' as default if undefined
  if (selectedTemplate) {
    let templateSettingsPageSize: string | undefined = undefined;
    if (selectedTemplate.settings) {
      try {
        const settingsObj = JSON.parse(selectedTemplate.settings);
        templateSettingsPageSize = settingsObj.pageSize;
      } catch {
        Log.error(`Error parsing template settings: ${selectedTemplate.settings}`);
      }
    }
    let normalizedPageSize = parsedObject.pageSize || templateSettingsPageSize;
    if (
      selectedTemplate.reportType === 'Itinerary' &&
      (normalizedPageSize === 'us-letter-itinerary' || normalizedPageSize === 'a4-itinerary')
    ) {
      normalizedPageSize = normalizedPageSize.replace('-itinerary', '');
    }
    data = {
      templateName:
        actionType === ReportTemplateFormType.edit
          ? selectedTemplate?.templateName
          : getDuplicateName(selectedTemplate?.templateName, templatesList),
      description: selectedTemplate.description,
      pageSize: normalizedPageSize
    } as ReportingTemplateRequest;
  }
  return data;
};
function getDuplicateName(templateName: string, templatesList: ReportTemplate[]): string {
  let newName = templateName;
  let count = 0;
  if (templatesList) {
    while (templatesList.some(template => template.templateName === newName)) {
      newName = `${count === 0 ? '(DUPLICATE) ' + newName : '(DUPLICATE ' + count + ') ' + newName}`;
      count++;
    }
  }
  return newName;
}
